<div style="overflow-x: scroll; min-width: 1000px;">
  <div class="credentials" style="width: 90vw;">
    <div style="font-size: 12px; color: darkgray;">Credentials are optional: they allow $CODE commands to work.</div>
    <form class="email-pass" [formGroup]="emailForm" (ngSubmit)="submitCredentials()" style="flex-direction: column; justify-content: flex-start;">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Email</mat-label>
        <input
          matInput
          required
          type="email"
          formControlName="email">
        <mat-error cotalker-validation-error-message controlName="email"></mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" color="accent">
        <mat-label>Password</mat-label>
        <input matInput
               required
               name="pass"
               type="password"
               formControlName="password">
        <mat-error cotalker-validation-error-message controlName="password"></mat-error>
      </mat-form-field>

      <button
        mat-flat-button
        id="token-button"
        color="accent"
        type="submit">
        getToken
      </button>

    </form>

    <form class="token">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Token</mat-label>
        <input
          matInput
          required
          type="text"
          [formControl]="tokenForm">
        <mat-error cotalker-validation-error-message controlName="tokenForm"></mat-error>
      </mat-form-field>
    </form>
  </div>

  <form class="cot-lang-expression" [formGroup]="cotLangForm" style="width: 90vw;">
    <div class="single-field">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Expression</mat-label>
        <input
          matInput
          required
          type="text"
          formControlName="expression">
        <mat-hint>e.g., $VALUE#hola|mundo</mat-hint>
        <mat-error cotalker-validation-error-message controlName="expression"></mat-error>
      </mat-form-field>
    </div>

    <div class="context-value">
      <mat-form-field appearance="fill">
        <mat-label>Contexts</mat-label>
        <mat-select formControlName="context">
          <mat-option>-- None --</mat-option>
          <mat-option *ngFor="let cntx of contexts" [value]="cntx.value">
            {{ cntx.display }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" color="accent">
        <mat-label>Value</mat-label>
        <input matInput
               required
               type="text"
               formControlName="value">
        <mat-hint>{{ cotLangValueExample }}</mat-hint>
        <mat-error cotalker-validation-error-message controlName="value"></mat-error>
      </mat-form-field>
    </div>

    <div class="single-field">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Output</mat-label>
        <input matInput
               required
               type="text"
               formControlName="output">
        <mat-hint>{{ cotLangOuputExample }}</mat-hint>
        <mat-error cotalker-validation-error-message controlName="output"></mat-error>
      </mat-form-field>
    </div>

  </form>

  <div class="response" style="width: 90vw;">
    <pre>{{ cotLangResponse }}</pre>
  </div>

  <div class="credentials">
    <div>
      <h2>COTLang V3 Quick reference</h2>
    </div>
    <pre>
  Base expressions
    parenthesis           : (any)
    pipes                 : a|b|c
    literals              : ```a```  NOTE: ` chars must be escaped
    literals              : abc      NOTE: = | ( ) [ ] # chars must be escaped

  Commands
    $JOIN                 : $JOIN#sep#a#b#c#...#n
    $CODE                 : $CODE#model#ex1#ex2#ex3#target
    $VALUE                : $VALUE#pipe
    $OUTPUT               : $OUTPUT#key#pipe
    $$TIME                : $$TIME#range#number
    $ENV                  : $ENV#BASEURL

  Functions
    size                  : [size=>a=b]
    toString              : [toString=>a=b]
    cast                  : [cast=>a=b]
    map                   : [map=>a=b]
    arrayToObject         : [arrayToObject=>a=b]
    isDefinedFilter       : [isDefinedFilter=>a=b]
    filter                : [filter=>a=b]
    filterIndex           : [filterIndex=>a=b]
    notEqualFilter        : [notEqualFilter=>a=b]
    simpleNotEqualFilter  : [simpleNotEqualFilter=>a=b]
    simpleEqualFilter     : [simpleEqualFilter=>a=b]
    concat                : [concat=>a=b]
    find                  : [find=>a=b]
    push                  : [push=>a=b]
    add                   : [add=>a=b]
    math                  : [math=>a=b]
    date                  : [date=>a=b]
    every                 : [every=>a=b]
    some                  : [some=>a=b]
    json                  : [json=>a=b]
    querystring           : [querystring=>a=b]
    cotanswer_list        : [cotanswer_list=>a=b]
    gencode               : [gencode=>a=b]
    </pre>

    <h2>Examples</h2>

    <table style="text-align: left; width: 952px; ">
      <tr>
        <th>#</th>
        <th>Input</th>
        <th>Result</th>
        <th>Context</th>
      </tr>
      <tr *ngFor="let example of examples; let index = index">
        <td>{{index + 1}}</td>
        <td style="">
          <span style='font-family: "Lucida Console", Monaco, monospace;'>{{example.input}}</span>
        <td>
          <pre style='font-family: "Lucida Console", Monaco, monospace;'>{{example.result | json}}</pre>
        </td>
        <td>
            <pre *ngIf="example.value">Context: {{example.value | json}}</pre>
            <pre *ngIf="example.output">Output: {{(example.output) | json}}</pre>
        </td>
      </tr>
    </table>

    <h2>Reference</h2>
    <table style="text-align: left; width: 952px;">
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Syntax</th>
        <th>Description</th>
      </tr>
      <tr *ngFor="let doc of documentation; let index = index">
        <td>{{index + 1}}</td>
        <td>{{doc.name}}</td>
        <td>{{doc.arguments}}</td>
        <td><pre>{{doc.description}}</pre></td>
      </tr>
    </table>

  </div>

</div>
